module.exports = __webpack_public_path__ + "img/eye-inspire.b94a59b0.png";